import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card h-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-accent text-white font-weight-bold" }, " Rekap Uang Tips ", -1)
const _hoisted_3 = { class: "card-body px-0 py-0" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-dark text-white" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "No"),
    /*#__PURE__*/_createElementVNode("th", null, "Keterangan"),
    /*#__PURE__*/_createElementVNode("th", null, "Nominal"),
    /*#__PURE__*/_createElementVNode("th", null, "Aksi")
  ])
], -1)
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailMoneyTips = _resolveComponent("DetailMoneyTips")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listMoneyTips, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: 'tips-' + index
                }, [
                  _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", null, _toDisplayString(item.description), 1),
                  _createElementVNode("td", null, _toDisplayString(item.value), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      onClick: _withModifiers(($event: any) => (_ctx.onClick(item)), ["prevent"])
                    }, "LIHAT", 8, _hoisted_7)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_DetailMoneyTips, {
      "modal-show": _ctx.showDetailModal,
      onOnHide: _ctx.onHideDetailModal,
      modalSize: "xlarge",
      tips: _ctx.details
    }, null, 8, ["modal-show", "onOnHide", "tips"]),
    _createVNode(_component_Modal, {
      title: "Recap Uang Tips",
      bodyText: _ctx.modalContent,
      "modal-show": _ctx.modalShow,
      modalSize: "medium"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("button", {
          class: "btn btn-accent",
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideModal && _ctx.hideModal(...args)))
        }, "OK")
      ]),
      _: 1
    }, 8, ["bodyText", "modal-show"])
  ], 64))
}